function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#36A4FF;}\n\t.st2{fill:#1D1E1C;}\n\t.st3{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#1D1E1C;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#EE8C96;}\n\t.st6{fill:#D9D9D8;}\n\t.st7{fill:#1D1D1B;}\n\t.st8{fill:none;stroke:#1D1D1B;stroke-width:0.89;stroke-miterlimit:10;}\n\t.st9{fill:none;stroke:#1D1D1B;stroke-width:7.7;stroke-miterlimit:10;}\n\tg .st0 {\n\t\tfill: #1D1D1B;\n\t}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M129.5,20.6c2.5-1.3,5.4-2,8.2-1.9c3.5,0,7,0.9,10,2.8s5.5,4.7,7,8c1.8,3.8,2.7,7.9,2.6,12 c0.1,4.2-0.8,8.3-2.6,12.1c-1.6,3.3-4,6.1-7,8s-6.4,2.9-10,2.8c-2.8,0.1-5.6-0.6-8.2-1.9c-2.2-1.2-4.1-2.9-5.5-4.9V85h-13.6V19.4 H124v6.3C125.3,23.5,127.2,21.8,129.5,20.6z M140.6,33.5c-1.8-1.9-4.3-3-7-2.9c-2.6,0-5.1,1-6.9,2.9c-2,2.2-3,5.1-2.8,8 c-0.2,3,0.9,5.8,2.8,8c3.6,3.8,9.7,3.9,13.5,0.3c0.1-0.1,0.2-0.2,0.3-0.3c2-2.2,3-5.1,2.9-8.1C143.6,38.6,142.6,35.7,140.6,33.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M164.3,29.5c1.6-3.3,4-6,7-8c3-1.9,6.4-2.8,10-2.8c2.9-0.1,5.7,0.6,8.2,1.9c2.2,1.2,4.1,2.9,5.5,5v-6.3h13.6 v44.4H195v-6.3c-1.4,2.1-3.3,3.8-5.5,5c-2.5,1.3-5.4,2-8.2,1.9c-3.5,0-6.9-0.9-9.9-2.8c-3.1-2-5.5-4.8-7-8 c-1.8-3.8-2.7-7.9-2.6-12.1C161.6,37.3,162.5,33.2,164.3,29.5z M192.2,33.5c-3.7-3.8-9.7-3.9-13.5-0.3c-0.1,0.1-0.2,0.2-0.2,0.2 c-1.9,1.9-2.8,4.6-2.8,8c-0.2,3,0.9,5.9,2.8,8.1c3.6,3.8,9.6,4,13.4,0.4c0.1-0.1,0.3-0.2,0.4-0.4c2-2.2,3-5.1,2.8-8 C195.2,38.6,194.2,35.7,192.2,33.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M258.1,23.9c3.1,3.4,4.7,8,4.7,13.9v26h-13.5V39.7c0.2-2.5-0.7-5-2.3-6.9c-3.5-3.3-8.9-3.3-12.4,0 c-1.6,1.9-2.5,4.4-2.3,6.9v24.1h-13.6V19.4h13.6v5.9c1.4-2,3.3-3.6,5.6-4.7c2.5-1.2,5.2-1.8,7.9-1.7 C250.8,18.9,255,20.6,258.1,23.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M272.1,29.5c1.6-3.3,4-6,7-8c3-1.9,6.4-2.8,10-2.8c2.8,0,5.5,0.6,8,1.8c2.3,1.1,4.3,2.8,5.7,4.9V4.9h13.6v58.9 h-13.6v-6.4c-1.3,2.2-3.2,3.9-5.5,5.1c-2.5,1.3-5.4,2-8.2,1.9c-3.5,0-7-0.9-10-2.8c-3.1-2-5.5-4.8-7-8c-1.8-3.8-2.7-7.9-2.6-12.1 C269.4,37.3,270.3,33.2,272.1,29.5z M300,33.5c-3.7-3.8-9.7-3.9-13.5-0.3c-0.1,0.1-0.2,0.2-0.2,0.2c-1.9,1.9-2.8,4.6-2.8,8 c-0.2,3,0.9,5.9,2.8,8.1c3.6,3.8,9.6,4,13.4,0.4c0.1-0.1,0.3-0.2,0.4-0.4c2-2.2,3-5.1,2.8-8C303,38.6,301.9,35.7,300,33.5L300,33.5 z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M326.2,29.5c1.6-3.3,4-6,7.1-8c3-1.9,6.4-2.8,10-2.8c2.9-0.1,5.7,0.6,8.2,1.9c2.2,1.2,4.1,2.9,5.5,5v-6.3h13.6 v44.4H357v-6.3c-1.4,2.1-3.3,3.9-5.5,5c-2.5,1.3-5.4,2-8.2,1.9c-3.5,0-6.9-0.9-9.9-2.8c-3.1-2-5.5-4.8-7.1-8 c-1.8-3.8-2.7-7.9-2.6-12.1C323.5,37.3,324.4,33.2,326.2,29.5z M354.1,33.5c-3.7-3.8-9.7-3.9-13.5-0.3c-0.1,0.1-0.2,0.2-0.2,0.2 c-2,2.2-3,5.1-2.8,8c-0.2,3,0.9,5.9,2.8,8.1c3.6,3.8,9.6,4,13.4,0.4c0.1-0.1,0.3-0.2,0.4-0.4c2-2.2,3-5.1,2.8-8 C357.1,38.6,356,35.7,354.1,33.5L354.1,33.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M416.9,21c2.4-1.4,5.2-2.1,8-2.1v14.4h-3.7c-3.4,0-5.9,0.7-7.6,2.2s-2.5,4-2.5,7.7v20.6h-13.6V19.4h13.6v7.4 C412.4,24.4,414.5,22.4,416.9,21z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M432.4,12.6c-1.5-1.3-2.3-3.2-2.3-5.2s0.8-3.9,2.3-5.3c1.6-1.4,3.7-2.2,5.9-2.1c2.1-0.1,4.2,0.7,5.8,2.1 c1.5,1.4,2.3,3.3,2.3,5.3s-0.8,3.9-2.3,5.2c-1.6,1.4-3.6,2.2-5.8,2.1C436.1,14.8,434,14.1,432.4,12.6z M445,19.4v44.4h-13.6V19.4 H445z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M454.7,29.5c1.6-3.3,4-6,7-8c3-1.9,6.4-2.8,10-2.8c2.8,0,5.5,0.6,8,1.8c2.3,1.1,4.3,2.8,5.7,4.9V4.9H499v58.9 h-13.6v-6.4c-1.3,2.2-3.2,3.9-5.5,5.1c-2.5,1.3-5.4,2-8.2,1.9c-3.5,0-7-0.9-10-2.8c-3.1-2-5.5-4.8-7-8c-1.8-3.8-2.7-7.9-2.6-12.1 C452.1,37.3,453,33.2,454.7,29.5z M482.6,33.5c-3.7-3.8-9.7-3.9-13.5-0.3c-0.1,0.1-0.2,0.2-0.2,0.2c-1.9,1.9-2.8,4.6-2.8,8 c-0.2,3,0.9,5.9,2.8,8.1c3.6,3.8,9.6,4,13.4,0.4c0.1-0.1,0.3-0.2,0.4-0.4c2-2.2,3-5.1,2.8-8C485.6,38.6,484.6,35.7,482.6,33.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M550.6,44.8h-30.8c0,2.4,1,4.6,2.7,6.3c1.6,1.5,3.6,2.2,5.8,2.2c3.4,0,5.8-1.4,7.1-4.3h14.5 c-0.7,2.9-2.1,5.6-4,7.9c-2,2.4-4.5,4.2-7.3,5.5c-3.1,1.4-6.4,2-9.8,2c-4.1,0.1-8.1-0.9-11.6-2.8c-3.4-1.8-6.1-4.6-8-8 c-2-3.7-3-7.9-2.9-12.1c-0.1-4.2,0.9-8.4,2.8-12.1c1.8-3.4,4.6-6.1,7.9-8c7.3-3.7,15.9-3.7,23.2-0.1c3.3,1.8,6,4.4,7.8,7.7 c1.9,3.6,2.9,7.6,2.8,11.7C550.9,42.2,550.8,43.5,550.6,44.8z M536.9,37.3c0.1-2.1-0.8-4.2-2.4-5.6c-1.7-1.4-3.8-2.1-6-2.1 c-2.1-0.1-4.2,0.6-5.8,2c-1.6,1.5-2.7,3.5-2.9,5.7H536.9z"
}));

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 45.3,
  cy: 42.9,
  r: 42
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M32.6,32.6l-5.2,8c0,0-3.5-3.8-1.7-6.7C27.3,31,31.3,31.9,32.6,32.6"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M57.8,32.6l5.2,8c0,0,3.5-3.8,1.7-6.7C63.1,31,59.1,31.9,57.8,32.6"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M45.2,51.1c-11.7,0-21.7,3.8-25.5,12.4c2.4,2.9,5.3,5.4,8.5,7.3c2.5-6.5,9.2-9.9,17-9.9s14.4,3.4,17,9.8 c3.2-1.9,6.1-4.4,8.5-7.3C66.9,54.9,56.9,51.1,45.2,51.1"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M45.2,60c-15.3,0-19.1,9.3-21.6,15.8c5,3,15.4,9.1,21.6,9.1S62.1,79,67.1,76C64.5,69.5,61.5,60,45.2,60"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M63.8,44.1c0,8.6-8.3,14-18.5,14s-18.5-5.4-18.5-14s8.3-17.2,18.5-17.2C55.5,26.9,63.8,35.5,63.8,44.1"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M59.7,21.8c-4.1-2.4-11.8-4.2-14.5-4.2c-2.6,0-10.4,1.9-14.5,4.2c-1.2,0.7-3.8,2.7-3.6,4.2 c0.4,3.8,5.5,5.5,5.5,5.5s-0.6,0.1-0.4,0.7c0.3,0.6,2,1.2,4.6,1c2.3-0.2,8.3-0.2,8.3-0.2s6,0.1,8.3,0.2c2.6,0.2,4.3-0.4,4.6-1 c0.3-0.6-0.4-0.7-0.4-0.7s5-1.7,5.5-5.5C63.4,24.5,60.9,22.5,59.7,21.8"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M58.1,31.7c-3.8-5.2-12.3-5-12.9-4.9c-0.6,0-9.1-0.2-12.9,4.9c3.8-2,7.1-3.2,12.9-3.2S54.3,29.7,58.1,31.7"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M50.6,35.7c-3.2,1.7-2,7.8,0.7,9.7c2.7,1.8,6.5-0.7,6-3.9C56.7,38.2,53.9,33.9,50.6,35.7"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M39.7,35.7c3.2,1.7,2,7.8-0.7,9.7c-2.7,1.8-6.5-0.7-6-3.9C33.6,38.2,36.4,33.9,39.7,35.7"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M37.6,39.1c0,0.7,0.6,1.3,1.3,1.3s1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3l0,0C38.2,37.8,37.6,38.4,37.6,39.1"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M50,39.1c0,0.7,0.6,1.3,1.3,1.3s1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3S50,38.4,50,39.1"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M42.6,46.1c0,0,0.7-0.8,2.6-0.8l0,0c1.9,0,2.6,0.8,2.6,0.8c0.7,1.1-1.4,3-2.6,3C43.9,49.1,41.9,47.2,42.6,46.1"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M49.5,50c-0.7-0.4-0.8,0.7-4.4,0.7c-3.6,0-3.7-1.2-4.3-0.7c-0.7,0.4-0.2,1.4,0.3,2.1c0.5,0.7,1.8,1.7,4,1.7 s3.5-1,4-1.7C49.7,51.4,50.2,50.4,49.5,50"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M46.3,52.4c-1.2,0-1.2,0.6-1.2,0.6s0-0.6-1.2-0.6S42.2,53,42.2,53c1.1,0.8,2.9,0.7,2.9,0.7s1.8,0,2.9-0.7 C48.1,53,47.5,52.4,46.3,52.4"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M45.2,56.8c0,0-10.7,0-15.3-4.3c0,0,4.7,5.8,15.3,5.8c10.6-0.1,15.3-5.8,15.3-5.8 C55.9,56.7,45.2,56.8,45.2,56.8"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M62,55.1c0,0-7.1,4.7-16.8,5c-9.7-0.3-16.8-5-16.8-5l-4.8,12.1c0,0,1.6,7.2,3.7,4C31.8,64.6,38.7,61,45.2,61 c6.6,0,13.6,3.7,17.9,10.2c2.2,3.2,3.7-4,3.7-4L62,55.1z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M45.2,80.6v4.3"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M45.2,84.9l0.1-5.9l11.6-7.4"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M33.7,71.6L45.3,79"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M45.2,62.4c-10.1,0-18.5,7.9-19.1,18c1.5,0.7,3,1.4,4.5,2c0-0.3,0-0.5,0-0.8c0-8.1,6.6-14.7,14.7-14.7 S60,73.5,60,81.6c0,0.3,0,0.5,0,0.8c1.5-0.6,3-1.2,4.5-2C63.7,70.3,55.3,62.4,45.2,62.4z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M62,55.1c0,0,2.5,14,1,14.9c-1.3,0.8-3.8,2.1-6.3,4.3c-0.4,0.4-3.5,3.5-1.8,6.2c0.9,1.5,2.7,1.9,4.5,1.9 c3.5-1.3,6.8-3,9.9-5.2c0.4-0.4,0.7-0.7,1-1.1c2.1-2.6,2-6.4,2-6.4C72.7,59.7,62,55.1,62,55.1z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M27.3,70c-1.5-0.9,1-14.9,1-14.9S17.7,59.7,18,69.8c0,0-0.1,3.8,2,6.4c0.2,0.2,0.4,0.5,0.6,0.7 c3.2,2.3,6.7,4.2,10.4,5.5c1.7,0,3.4-0.4,4.3-1.9c1.7-2.7-1.3-5.8-1.8-6.2C31.1,72.2,28.6,70.8,27.3,70z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M49.8,78.9c0-2.5-2.1-4.6-4.6-4.6s-4.6,2.1-4.6,4.6s2.1,4.6,4.6,4.6S49.8,81.4,49.8,78.9L49.8,78.9"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 550.9 85",
    style: {
      enableBackground: "new 0 0 550.9 85"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.37f5044e4de0ffe7dda55c30a77e817a.svg";
export { ForwardRef as ReactComponent };